// show available products
// (function () {
//     const links = document.querySelectorAll('a')
  
//     links.forEach(link => {
//       if (link.getAttribute('href') && link.getAttribute('href').toString().includes("/collections/") && !link.getAttribute('href').toString().includes("/products/")) {
//         const href = link.getAttribute('href')
//         link.setAttribute('href', `${href}?filter.v.availability=1&sort_by=manual`)
//       }
//     });
//   })();
// show available products

// size calculator
(function () {
  function readRanges(config, variants, sizePosition) {
    if (!config || !Array.isArray(config.ranges) || !config.ranges.length || !Array.isArray(variants) || !variants.length || !Number.isInteger(sizePosition) || sizePosition < 0) return null;
    if (config.option_position !== undefined && config.option_position !== sizePosition + 1) return null;

    const productSizes = new Set(variants.map((variant) => variant.options?.[sizePosition]));
    const ranges = config.ranges;
    for (const range of ranges) {
      if (!range || typeof range !== 'object' || Array.isArray(range) || typeof range.size !== 'string' || !range.size.trim() || range.size !== range.size.trim() || !productSizes.has(range.size)) return null;
      if (![range.height_min, range.height_max, range.weight_min, range.weight_max].every((value) => typeof value === 'number' && Number.isFinite(value))) return null;
      if (range.height_min < 0 || range.weight_min < 0 || range.height_min >= range.height_max || range.weight_min >= range.weight_max) return null;
    }

    for (let first = 0; first < ranges.length; first += 1) {
      for (let second = first + 1; second < ranges.length; second += 1) {
        const a = ranges[first];
        const b = ranges[second];
        if (a.size !== b.size && a.height_min < b.height_max && b.height_min < a.height_max && a.weight_min < b.weight_max && b.weight_min < a.weight_max) return null;
      }
    }

    return ranges;
  }

  function initCalculator(calculator) {
    if (calculator.dataset.initialized) return;

    let variants;
    let config;
    try {
      variants = JSON.parse(calculator.querySelector('.product-size-calculator__variants').textContent);
      config = JSON.parse(calculator.querySelector('.product-size-calculator__ranges').textContent);
    } catch (error) {
      calculator.remove();
      return;
    }
    const sizePosition = Number(calculator.dataset.sizePosition);
    const ranges = readRanges(config, variants, sizePosition);
    if (!ranges) {
      console.warn('Size calculator: invalid or overlapping product ranges.');
      calculator.remove();
      return;
    }
    calculator.dataset.initialized = 'true';

    const dialog = calculator.querySelector('.product-size-calculator__dialog');
    const trigger = calculator.querySelector('.product-size-calculator__trigger');
    const close = calculator.querySelector('.product-size-calculator__close');
    const form = calculator.querySelector('.product-size-calculator__form');
    const heightInput = form.querySelector('[name="height"]');
    const weightInput = form.querySelector('[name="weight"]');
    const result = calculator.querySelector('.product-size-calculator__result');
    const addToCart = calculator.querySelector('.product-size-calculator__add-to-cart');
    const cartError = calculator.querySelector('.product-size-calculator__error');
    const section = calculator.closest('section');
    const picker = section?.querySelector('variant-radios, variant-selects');
    let recommendedSize = null;
    let recommendedVariant = null;
    let recommendationIsNearest = false;

    const heightScale = ranges.reduce((total, range) => total + range.height_max - range.height_min, 0) / ranges.length;
    const weightScale = ranges.reduce((total, range) => total + range.weight_max - range.weight_min, 0) / ranges.length;

    function closestRange(height, weight) {
      return ranges.reduce((closest, range) => {
        const heightGap = Math.max(range.height_min - height, height - range.height_max, 0) / heightScale;
        const weightGap = Math.max(range.weight_min - weight, weight - range.weight_max, 0) / weightScale;
        const distance = Math.hypot(heightGap, weightGap);
        return distance < closest.distance ? { range, distance } : closest;
      }, { range: null, distance: Infinity }).range;
    }

    heightInput.min = String(Math.min(...ranges.map((range) => range.height_min)));
    weightInput.min = String(Math.min(...ranges.map((range) => range.weight_min)));
    calculator.hidden = false;

    function selectedOptions() {
      if (!picker) return [];
      return picker.matches('variant-radios')
        ? Array.from(picker.querySelectorAll('fieldset')).map((fieldset) => fieldset.querySelector('input:checked')?.value)
        : Array.from(picker.querySelectorAll('select')).map((select) => select.value);
    }

    function updateRecommendation() {
      const options = selectedOptions();
      const otherOptionsSelected = variants[0].options.every((_, index) =>
        index === sizePosition || Boolean(options[index])
      );
      const matches = variants.filter((variant) =>
        variant.options[sizePosition] === recommendedSize &&
        variant.options.every((option, index) => index === sizePosition || !options[index] || options[index] === option)
      );
      const available = matches.some((variant) => variant.available);
      recommendedVariant = otherOptionsSelected && matches.length === 1 && matches[0].available ? matches[0] : null;
      addToCart.hidden = !recommendedVariant;
      result.textContent = `${recommendationIsNearest ? calculator.dataset.nearest : calculator.dataset.recommended} ${recommendedSize}. ${
        (!otherOptionsSelected || matches.length > 1) && available ? calculator.dataset.selectOptions :
          available ? calculator.dataset.available : calculator.dataset.unavailable
      }`;
    }

    function clearRecommendation() {
      recommendedSize = null;
      recommendedVariant = null;
      recommendationIsNearest = false;
      addToCart.hidden = true;
      result.textContent = '';
      cartError.hidden = true;
      cartError.textContent = '';
    }

    trigger.addEventListener('click', () => {
      dialog.showModal();
      heightInput.focus();
    });
    close.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    });
    dialog.addEventListener('close', () => trigger.focus());
    form.addEventListener('change', (event) => event.stopPropagation());
    form.addEventListener('input', clearRecommendation);
    picker?.addEventListener('change', () => {
      if (recommendedSize) updateRecommendation();
    });

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      clearRecommendation();
      const height = Number(heightInput.value);
      const weight = Number(weightInput.value);

      if (!heightInput.value || !weightInput.value || !Number.isFinite(height) || !Number.isFinite(weight)) {
        result.textContent = calculator.dataset.required;
        (!heightInput.value ? heightInput : weightInput).focus();
        return;
      }
      const matchingRange = ranges.find((range) =>
        height >= range.height_min && height < range.height_max &&
        weight >= range.weight_min && weight < range.weight_max
      );
      if (height <= 0 || weight <= 0) {
        result.textContent = calculator.dataset.required;
        return;
      }

      recommendedSize = (matchingRange || closestRange(height, weight)).size;
      recommendationIsNearest = !matchingRange;
      updateRecommendation();
    });

    addToCart.addEventListener('click', async () => {
      if (!recommendedSize || addToCart.disabled) return;
      updateRecommendation();
      if (!recommendedVariant) return;

      const purchaseForm = section?.querySelector('.product__purchase product-form form[data-type="add-to-cart-form"]');
      if (!purchaseForm) return;
      const cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      const formData = new FormData(purchaseForm);
      formData.set('id', String(recommendedVariant.id));
      if (cart) {
        formData.set('sections', cart.getSectionsToRender().map((item) => item.id).join(','));
        formData.set('sections_url', window.location.pathname);
        cart.setActiveElement?.(trigger);
      }

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      delete config.headers['Content-Type'];
      config.body = formData;
      addToCart.disabled = true;
      addToCart.setAttribute('aria-busy', 'true');
      cartError.hidden = true;

      let addedItem;
      try {
        const response = await fetch(routes.cart_add_url, config);
        const item = await response.json();
        if (!response.ok || item.status) throw new Error(typeof item.description === 'string' ? item.description : calculator.dataset.cartError);
        addedItem = item;
      } catch (error) {
        cartError.textContent = error instanceof TypeError ? calculator.dataset.cartError : error.message || calculator.dataset.cartError;
        cartError.hidden = false;
      } finally {
        addToCart.disabled = false;
        addToCart.removeAttribute('aria-busy');
      }

      if (!addedItem) return;
      dialog.close();
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'product-form' });
      if (cart) {
        cart.classList.remove('is-empty');
        cart.renderContents(addedItem);
      } else {
        window.location = window.routes.cart_url;
      }
    });
  }

  function initSizeGuide(guide) {
    if (guide.dataset.initialized) return;
    const trigger = guide.querySelector('[data-type="button"]');
    const popup = guide.querySelector('.grid-popup');
    const close = popup?.querySelector('.close');
    if (!trigger || !popup || !close) return;
    guide.dataset.initialized = 'true';

    const hide = () => {
      popup.classList.remove('active');
      popup.setAttribute('aria-hidden', 'true');
      popup.setAttribute('inert', '');
      document.querySelector('header')?.classList.remove('header-none');
      document.body.classList.remove('fixedScroll');
      trigger.focus();
    };
    trigger.addEventListener('click', () => {
      popup.removeAttribute('aria-hidden');
      popup.removeAttribute('inert');
      popup.classList.add('active');
      document.querySelector('header')?.classList.add('header-none');
      document.body.classList.add('fixedScroll');
      close.focus();
    });
    close.addEventListener('click', hide);
    popup.addEventListener('click', (event) => {
      if (event.target === popup) hide();
    });
    popup.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') hide();
    });
  }

  function initSizeTools(root) {
    root.querySelectorAll('.product-size-calculator').forEach(initCalculator);
    root.querySelectorAll('.custom-size-grid').forEach(initSizeGuide);
  }

  initSizeTools(document);
  document.addEventListener('shopify:section:load', (event) => initSizeTools(event.target));
})();
// size calculator

// Keep the size guide and calculator together immediately below the size choices.
(function () {
  function positionSizeTools(root) {
    document.querySelectorAll('section[id^="MainProduct-"] product-info.product__info-container').forEach((info) => {
      if (!root.contains(info) || info.querySelector('.product__size-tools')) return;

      const picker = info.querySelector('variant-radios, variant-selects');
      const calculator = info.querySelector('.product-size-calculator');
      const sizePosition = Number(calculator?.dataset.sizePosition);
      const pickerOptions = Array.from(picker?.children || []).filter((node) => node.matches('.product-form__input'));
      const sizeOption = pickerOptions[sizePosition] || picker?.querySelector('.selector--Size');
      if (!sizeOption) return;

      const tools = [
        ...Array.from(info.children).filter((node) => node.matches('.product__size-guide')),
        ...Array.from(info.children).filter((node) => node.matches('.product-size-calculator'))
      ];
      if (!tools.length) return;

      const toolRow = document.createElement('div');
      toolRow.className = 'product__size-tools';
      toolRow.append(...tools);
      sizeOption.classList.add('has-size-tools');
      sizeOption.after(toolRow);
    });
  }

  positionSizeTools(document);
  document.addEventListener('shopify:section:load', (event) => positionSizeTools(event.target));
})();

(function () {
  if (document.querySelector('.product__chast')) {
      if (document.querySelector('.product__chast')) {  
        document.querySelector('.product__chast a').addEventListener('click', () => {
          document.querySelector('.product__chast .chast-popup').classList.add('active')
          document.querySelector('header').classList.add('header-none')
          document.querySelector('body').classList.add('fixedScroll')
        })
      
        document.querySelector('.product__chast .chast-popup .close').addEventListener('click', () => {
          document.querySelector('.product__chast .chast-popup').classList.remove('active')
          document.querySelector('header').classList.remove('header-none')
          document.querySelector('body').classList.remove('fixedScroll')
        })
      }
  
      document.querySelectorAll('.product__chast').forEach(el => {
        el.addEventListener('click', e => {
          if (e.target.classList.contains('custom-popup')) {
            e.target.classList.remove('active')
            document.querySelector('header').classList.remove('header-none')
            document.querySelector('body').classList.remove('fixedScroll')
          }
        })
      })
  }
})();

(function () {
  if (document.querySelector('.banner-form-popup')) {

    document.querySelectorAll('a[href="#banner-form"]').forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        document.querySelector('.banner-form-popup').classList.add('active');
        document.querySelector('header').classList.add('header-none');
        document.querySelector('body').classList.add('fixedScroll');
      });
    });

    document.querySelector('.banner-form-popup .close').addEventListener('click', () => {
      document.querySelector('.banner-form-popup').classList.remove('active');
      document.querySelector('header').classList.remove('header-none');
      document.querySelector('body').classList.remove('fixedScroll');
    });

    document.querySelectorAll('.banner-form-popup').forEach(el => {
      el.addEventListener('click', e => {
        if (e.target.classList.contains('custom-popup')) {
          e.target.classList.remove('active');
          document.querySelector('header').classList.remove('header-none');
          document.querySelector('body').classList.remove('fixedScroll');
        }
      });
    });
  }
})();

// style for sendpulse forms
// (function () {
//   const addStylesToFormFooter = () => {
//     const hostElement = document.querySelector('.new_footer .sp-inline-popup');
//     const shadowRoot = hostElement.shadowRoot;
//     const style = document.createElement('style');
//     style.textContent = `
//       .sp-inline-popup  .sp-popup-popup .sp-popup.sp-popup-subscribe {
//         box-shadow: none !important;
//         border-radius: 0 !important;
//       }
//       .sp-inline-popup  .sp-popup-popup .sp-popup .sp-popup-info {
//         padding: 0 !important;
//       }
//       .sp-inline-popup  .sp-popup-popup .sp-popup .sp-popup-content {
//         border-radius: 0!important;
//       }
//       .sp-inline-popup  .sp-poweredby {
//         display:none !important;
//       }
//       .sp-inline-popup  .sp-popup-popup .sp-popup-form {
//         flex-direction: row !important;
//         gap:0 !important;
//       }
//       .button-group.svelte-1cqpana .sp-popup-button-image.svelte-1cqpana {
//         background-size: 20px !important;
//       }
//       .sp-inline-popup  .sp-submit .sp-submit-animation-circle.sp-submit-anim-checkmark .sp-submit-animation-draw:after {
//         height: 22px !important;
//         width: 15px !important;
//         left: 8px !important;
//         top: 21px !important;
//       }
//       .sp-inline-popup  .sp-submit .sp-submit-animation-circle {
//         height: 45px !important;
//         min-height: 45px !important;
//         min-width: 45px !important;
//         width: 45px !important;
//       }
//       .edu-registration-complete .sp-submit-animation {
//         display:none !important;
//       }
//       .sp-inline-popup  .sp-submit .sp-submit-animation {
//         opacity: 1 !important;
//       }
//       .sp-inline-popup  .sp-popup-input-main.svelte-1pwp4mq .sp-popup-input-placeholder.svelte-1pwp4mq {
//         top:-3px !important;
//       }
//     `;
  
//     shadowRoot.appendChild(style);
//   }
//   const addStylesToFormContacts = () => {
//     const hostElement = document.querySelector('#contact__form .sp-inline-popup');
//     const shadowRoot = hostElement.shadowRoot;
//     const style = document.createElement('style');
//     style.textContent = `
//       .sp-inline-popup  .sp-popup-popup .sp-popup{
//         box-shadow: none !important;
//         border-radius: 0 !important;
//       }
//       .sp-inline-popup  .sp-popup-popup .sp-popup .sp-popup-info {
//         padding: 0 !important;
//         padding-top: 10px !important;
//       }
//       .sp-inline-popup  .sp-popup-popup .sp-popup .sp-popup-content {
//         border-radius: 0 !important;
//       }
//       .sp-inline-popup  .sp-poweredby {
//         display:none !important;
//       }
//       .sp-inline-popup  .sp-popup.sp-popup-theme-white .sp-popup-input-placeholder {
//         color: #000 !important;
//       }
//     `;
  
//     shadowRoot.appendChild(style);
//   }
    

//   function waitForElement(selector, callback) {
//     const observer = new MutationObserver((mutations) => {
//       for (let mutation of mutations) {
//         if (mutation.type === 'childList') {
//           const element = document.querySelector(selector);
//           if (element) {
//             callback(element);
//             observer.disconnect();
//             break;
//           }
//         }
//       }
//     });
  
//     observer.observe(document.documentElement, { childList: true, subtree: true });
//   }
  
//   waitForElement('.new_footer .sp-inline-popup', (element) => {
//     addStylesToFormFooter()
//   });

//   if (document.querySelector('#contact__form')) {
//     waitForElement('.new_footer .sp-inline-popup', (element) => {
//       addStylesToFormContacts()
//     });
//   }
  
// })();
// style for sendpulse forms

// Show more/less text
(function () {
  if (document.querySelector('.toggle-button')) {
    const toggleButtons = document.querySelectorAll('.toggle-button');

    toggleButtons.forEach(button => {
        button.addEventListener('click', function() {
            const textContent = this.previousElementSibling;

            if (textContent.classList.contains('expanded')) {
                textContent.style.maxHeight = '100px'; // Collapsed state height
                textContent.classList.remove('expanded');
                this.textContent = this.dataset.more;
            } else {
                const scrollHeight = textContent.scrollHeight;
                textContent.style.maxHeight = scrollHeight + 'px';
                textContent.classList.add('expanded');
                this.textContent = this.dataset.less;
            }
        });
    });
  }
})();
// Show more/less text

// redirect to COM
// (function () {
//   function redirectToInternationalSite() {
//     const locationKey = 'userLocation';
//     const locationTimeKey = 'userLocationTime';

//     // 👉 Настройки
//     const cacheDays = 7;  // срок хранения (в днях)
//     const redirectUrl = 'https://farfieworldwide.com'; // адрес для редиректа

//     const locationExpiry = cacheDays * 24 * 60 * 60 * 1000;
//     const now = Date.now();

//     // достаём сохранённые данные
//     const userLocation = localStorage.getItem(locationKey);
//     const locationTime = localStorage.getItem(locationTimeKey);

//     if (userLocation && locationTime && (now - locationTime < locationExpiry)) {
//       // если данные ещё актуальны
//       if (userLocation !== 'UA') {
//         window.location.href = redirectUrl;
//       }
//     } else {
//       // если данных нет или срок истёк → запрос к API
//       fetch('https://api.ipregistry.co/?key=ira_pmQVZQ3n1OyRtFIB0u3kVVby66hLZn2HYWTY')
//         .then(response => response.json())
//         .then(data => {
//           const countryCode = data.location.country.code;

//           // сохраняем страну и время в localStorage
//           localStorage.setItem(locationKey, countryCode);
//           localStorage.setItem(locationTimeKey, now);

//           if (countryCode !== 'UA') {
//             window.location.href = redirectUrl;
//           }
//         })
//         .catch(error => {
//           console.error('Error fetching user location:', error);
//         });
//     }
//   }

//   redirectToInternationalSite();
// })();
// redirect to COM

(function () {
  const menuDrawer = document.querySelector('#mobilka header-drawer');
  const menuDrawerDetails = menuDrawer ? menuDrawer.querySelector('.menu-drawer-container') : null;
  const menuButton = menuDrawerDetails ? menuDrawerDetails.querySelector('summary.header__icon--menu') : null;
  const menuDrawerPanel = menuDrawer ? menuDrawer.querySelector('#menu-drawer.menu-drawer') : null;
  const isHomePage = document.body.classList.contains('index');
  const mobileMenuQuery = window.matchMedia('(max-width: 749px)');
  const desktopSidebarHoverQuery = window.matchMedia('(min-width: 990px) and (hover: hover) and (pointer: fine)');

  if (!menuButton || !menuDrawerDetails || !menuDrawerPanel) return;

  const syncHomeDrawerOverlayTop = () => {
    const sectionHeader = document.querySelector('.section-header');
    const headerWrapper = document.querySelector('.header-wrapper');
    const overlayTarget = sectionHeader || headerWrapper;
    const overlayTop = overlayTarget ? Math.max(0, Math.floor(overlayTarget.getBoundingClientRect().top)) : 0;

    document.documentElement.style.setProperty('--home-drawer-overlay-top', `${overlayTop}px`);
  };

  let hasEnteredDesktopSidebar = false;

  const syncMenuButton = () => {
    const isOpen = menuDrawerDetails.hasAttribute('open');
    if (isOpen) syncHomeDrawerOverlayTop();
    if (!isOpen) hasEnteredDesktopSidebar = false;
    menuButton.classList.toggle('active', isOpen);
    menuButton.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    document.body.classList.toggle('home-menu-drawer-open', isHomePage && isOpen);
    document.body.classList.toggle('mobile-menu-drawer-open', mobileMenuQuery.matches && isOpen);
  };

  const isOutsideMenuTarget = (target) => {
    return !menuDrawerPanel.contains(target) && !menuButton.contains(target);
  };

  const stopOutsideEvent = (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (typeof event.stopImmediatePropagation === 'function') {
      event.stopImmediatePropagation();
    }
  };

  const isDesktopSidebarOpen = () => {
    return desktopSidebarHoverQuery.matches
      && menuDrawerDetails.hasAttribute('open')
      && menuDrawerDetails.classList.contains('menu-opening');
  };

  const closeMenuDrawer = () => {
    if (!menuDrawerDetails.hasAttribute('open')) return;

    menuButton.click();
    requestAnimationFrame(syncMenuButton);
    setTimeout(syncMenuButton, 500);
  };

  let suppressNextOutsideClick = false;

  menuDrawerPanel.addEventListener('mouseenter', () => {
    if (!desktopSidebarHoverQuery.matches) return;
    hasEnteredDesktopSidebar = true;
  });

  menuDrawerPanel.addEventListener('mouseleave', () => {
    if (!isDesktopSidebarOpen() || !hasEnteredDesktopSidebar) return;

    hasEnteredDesktopSidebar = false;
    closeMenuDrawer();
  });

  document.addEventListener('pointermove', (event) => {
    if (!isDesktopSidebarOpen() || !isOutsideMenuTarget(event.target)) return;

    closeMenuDrawer();
  }, true);

  document.addEventListener('pointerdown', (event) => {
    if (!menuDrawerDetails.hasAttribute('open')) return;
    if (!isOutsideMenuTarget(event.target)) return;

    suppressNextOutsideClick = true;
    stopOutsideEvent(event);
    closeMenuDrawer();

    setTimeout(() => {
      suppressNextOutsideClick = false;
    }, 550);
  }, true);

  document.addEventListener('click', (event) => {
    const isOpen = menuDrawerDetails.hasAttribute('open');

    if ((!isOpen && !suppressNextOutsideClick) || !isOutsideMenuTarget(event.target)) return;

    stopOutsideEvent(event);
    if (isOpen) closeMenuDrawer();
    suppressNextOutsideClick = false;
  }, true);

  menuDrawerDetails.addEventListener('toggle', syncMenuButton);
  window.addEventListener('resize', syncMenuButton);

  new MutationObserver(syncMenuButton).observe(menuDrawerDetails, {
    attributes: true,
    attributeFilter: ['class', 'open'],
  });

  syncMenuButton();
})();

// document.addEventListener("scroll", function () {
//   const logo = document.querySelector(".sticky-main-logo");
  
//   if (window.scrollY > 400) {
//     logo.classList.add("sticky");
//   } else {
//     logo.classList.remove("sticky");
//   }
// });

// Header transparent
(function () {
  document.addEventListener('DOMContentLoaded', function() {
    const header = document.querySelector('.header-wrapper');
    const isHome = document.body.classList.contains('index');

    if (!isHome || !header) return;

    header.classList.add('header--transparent');
    header.classList.remove('header--scrolled-gray');
  });
})();
// Header transparent

// product media slider
(function () {
  function initProductGalleries(root) {
    root.querySelectorAll('.farfi-product-swiper-container').forEach((container) => {
      if (container.dataset.swiperInitialized) return;

      const gallery = container.querySelector('.farfi-product-swiper');
      const slides = gallery?.querySelector('.swiper-wrapper')?.children;
      if (!gallery || !slides?.length) return;

      container.dataset.swiperInitialized = 'true';
      const hasMultipleSlides = slides.length > 1;
      const thumbnails = container.querySelector('.farfi-product-swiper-thumbs');
      const thumbnailCount = thumbnails?.querySelector('.swiper-wrapper')?.children.length || 0;
      const thumbnailSwiper = hasMultipleSlides && thumbnailCount
        ? new Swiper(thumbnails, {
            direction: 'vertical',
            loop: false,
            spaceBetween: 20,
            freeMode: true,
            watchSlidesProgress: true,
            slidesPerView: Math.min(4, thumbnailCount),
          })
        : null;

      const options = {
        loop: hasMultipleSlides,
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 300,
        effect: 'slide',
        grabCursor: true,
        longSwipesRatio: 0.25,
        lazyPreloadPrevNext: 1,
        navigation: {
          nextEl: gallery.querySelector('.swiper-button-next'),
          prevEl: gallery.querySelector('.swiper-button-prev'),
        },
        pagination: {
          el: gallery.querySelector('.swiper-pagination'),
          type: 'fraction',
        },
      };

      if (thumbnailSwiper) options.thumbs = { swiper: thumbnailSwiper };
      new Swiper(gallery, options);
    });
  }

  initProductGalleries(document);
  document.addEventListener('shopify:section:load', (event) => initProductGalleries(event.target));
})();


document.addEventListener('DOMContentLoaded', () => {
  const modal = document.getElementById('productGalleryModal');
  const modalImages = modal.querySelector('.product-gallery-modal__images');
  const closeBtn = modal.querySelector('.product-gallery-modal__close');
  const overlay = modal.querySelector('.product-gallery-modal__overlay');

  const productImages = document.querySelectorAll(
    '.farfi-product-swiper .swiper-slide img'
  );

  const closeModal = () => {
    modal.classList.remove('active');
    document.body.style.overflow = '';
  };

  productImages.forEach((img) => {
    img.addEventListener('click', () => {
      modalImages.innerHTML = '';

      productImages.forEach((image) => {
        const modalImg = document.createElement('img');
        modalImg.src = image.currentSrc || image.src;
        modalImg.alt = image.alt || '';

        // 🔥 закриття по кліку на фото
        modalImg.addEventListener('click', closeModal);

        modalImages.appendChild(modalImg);
      });

      modal.classList.add('active');
      document.body.style.overflow = 'hidden';
    });
  });

  closeBtn.addEventListener('click', closeModal);
  overlay.addEventListener('click', closeModal);
});
// product media slider

// cart drawer related products
(function () {
  document.addEventListener('DOMContentLoaded', function() {
    var slider = document.querySelector('.drawer_related_products_slider');
    var container = slider?.querySelector('.swiper-wrapper');
    if (!container) return;

    var allProducts = slider.querySelectorAll('.swiper-slide');
    var productArray = Array.prototype.slice.call(allProducts);
    var shuffled = productArray.sort(function() { return 0.5 - Math.random() });
    var selected = shuffled.slice(0, 8);

    container.innerHTML = '';
    
    selected.forEach(function(product) {
      product.classList.remove('hidden')
      container.appendChild(product);
    });
    
    var swiper = new Swiper(slider, {
      slidesPerView: 'auto',
        spaceBetween: 10,
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        }
    });
  });
})();
// cart drawer related products
